import { gql } from "graphql-tag";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  CreateOrUpdateFanClubGroupDocument,
  RemoveAdminFromFanClubGroupDocument,
} from "src/generated-gql/graphql";
import { take } from "rxjs";

export const bulkRemoveFanClubAdmin: BulkAction = {
  location: "fan-club-group-table",
  label: "Remove Selected",
  icon: "warning",
  iconClass: "is-warning",
  onClick: ({ selection, injector, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    modalService
      .dialog({
        title: `Remove ${selection.length}  fan club admin ?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Remove", returnValue: selection },
        ],
      })
      .subscribe((response) => {
        const ids: string[] = [];

        let fanClubId = "";
        for (const item in response) {
          ids.push(response[item].user.id);
          if (!fanClubId) {
            fanClubId = response[item].fanClubId;
          }
        }

        dataService
          .mutate(RemoveAdminFromFanClubGroupDocument, {
            input: {
              fanClubId,
              userIds: ids,
            },
          })
          .pipe(take(1))
          .subscribe((res) => {
            if (res.removeFromFanClubGroup) {
              notificationService.success(
                `Remove ${ids.length} admin successfully`
              );
              hostComponent.refresh();
              clearSelection();
            }
          });
      });
  },
};
